import React, { useEffect, useRef } from "react";
import "./Ads.css";
import logo_FalconBeat from '../Assets/Logo_falcon_beat13e.png';
import laptop_FalconBeat from "../Images/falconbeatlaptop.png";
import { useTranslation } from "react-i18next";

/* ============================================================
   ADS COMPONENT — Falcon Beats
   ------------------------------------------------------------
   Pour modifier :
   - Image          : remplacez src="..." dans <img>
   - Logo           : remplacez src="..." dans le bloc .ads-logo
   - Lien WA        : remplacez href="#whatsapp" par votre lien
   - Lien principal : remplacez href="#falcon" par votre lien
   - Couleurs       : voir les variables CSS dans Ads.css
   ============================================================ */

const Ads = () => {
    const sectionRef = useRef(null);

    const { t } = useTranslation();

    useEffect(() => {
        const section = sectionRef.current;
        if (!section) return;

        const leftEl = section.querySelector(".ads-image-wrapper");
        const rightEl = section.querySelector(".ads-text-wrapper");

        // Intersection Observer pour déclencher les animations au scroll
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        leftEl.classList.add("ads-animate-in");
                        rightEl.classList.add("ads-animate-in");
                        observer.disconnect(); // animate une seule fois
                    }
                });
            },
            {
                threshold: 0.2, // déclenche quand 20% de la section est visible
            }
        );

        observer.observe(section);

        return () => observer.disconnect();
    }, []);

    return (

        <>

    <section className="ads-section" ref={sectionRef}>
            <div className="ads-container">

                {/* ── DIV GAUCHE : Image ────────────────────────────── */}
                {/* Modifiez ads-image-wrapper dans le CSS pour changer
            le background, le padding ou la largeur */}
                <div className="ads-image-wrapper">
                    <img src={laptop_FalconBeat} alt="Falcon Beats logo" className="ads-image" />
                </div>

                {/* ── DIV DROITE : Texte ────────────────────────────── */}
                {/* Modifiez ads-text-wrapper dans le CSS pour changer
            le background, le padding ou la largeur */}
                <div className="ads-text-wrapper">

                    {/* Logo — remplacez le src par votre logo réel */}
                    <div className="ads-logo">

                        <img src={logo_FalconBeat} alt="Falcon Beats logo" className="ads-logo" />

                    </div>

                    {/* Titre principal */}
                    <h1 className="ads-title">
                        {t("Ads-Falcon-Beat.Title")}
                    </h1>

                    {/* Paragraphe descriptif */}
                    <p className="ads-description">
                        {t("Ads-Falcon-Beat.ContentLine1")}
                       <strong style={{color:"#72c0fc"}}> {t("Ads-Falcon-Beat.ContentLine2")} </strong>
                        <br /><br />
                        {t("Ads-Falcon-Beat.ContentLine3")}
                    </p>

                    {/* Zone boutons */}
                    <div className="ads-buttons">

                        {/* Bouton principal — modifiez href="#falcon" */}
                        <a
                            href="https://www.falconbeat.nl"
                            className="ads-btn ads-btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t("Ads-Falcon-Beat.BtnLine")}
                        </a>

                        {/* Bouton WhatsApp — modifiez href="#whatsapp" par votre lien WA */}
                        <a
                            href="https://wa.me/31685533124?text=Bonjour%20je%20souhaite%20un%20devis"
                            className="ads-btn ads-btn-whatsapp"
                            style={{border:"2px solid #0dd734", color:"#0dd734"}}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {/* Icône SVG WhatsApp inline */}
                            <svg
                                className="ads-wa-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                aria-hidden="true"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                            </svg>
                            WhatsApp
                        </a>

                    </div>
                </div>
            </div>
        </section>
      </>

    );
};

export default Ads;